import React from "react"
import Markdown from "@components/Markdown"
export default ({ theme, children, ...props }) => {
  let color = ""

  switch (theme) {
    case "blue-bg":
      color = "text-white"
      break
    case "white-bg":
      color = "text-dblue"
      break
    case "gray-bg":
      color = "text-dblue"
      break
  }
  return (
    <h2
      className={`font-inter text-20 desk:text-[40px] font-medium ${color} mb-2 md:mb-3 desk:mb-[20px] leading-120% desk:leading-normal ${
        props.className || ""
      }`}
    >
      {children}
    </h2>
  )
}
